
<script setup>

  import { ArrowRightCircleIcon } from '@heroicons/vue/24/outline';

  import AudioPlayer from '../components/audio-player.vue';

  import ParallaxLayer from '../components/parallax-layer.vue';

  import backgroundPath from '../images/rough-background.jpg';

  import layerPaths from '../images/activity-2-part-4-layer-*.png';

  import audio_s1e2_334_505 from '../audio/s1e2_334_505.mp3';

  import track_s1e2_334_505 from '../audio/s1e2_334_505.vtt';

  const layers = Object.values( layerPaths );

</script>

<template>

  <article>

    <div class="grid items-center justify-center min-h-view bg-fixed bg-cover bg-center"
    
      :style="{ backgroundImage: `url( ${ backgroundPath } )` }">

      <ParallaxLayer v-for="( path, index ) in layers" :z="30 - index * 10" class="row-start-1 col-start-1 w-screen h-full">

        <img :src="path" alt="" aria-hidden="true" class="w-full h-full object-cover scale-110 transition-[opacity,filter] grayscale opacity-10 xl:grayscale-0 xl:opacity-100" />

      </ParallaxLayer>

      <div class="row-start-1 col-start-1 relative p-6 md:p-12 lg:p-24">

        <div class="max-w-xl">

          <h3 class="text-5xl font-heading uppercase">

            You arrive at Shenandoah National Park

          </h3>

          <p class="mt-8 text-neutral-700">

            ...and a ranger at the Front Royal Entrance Station hands you a map.

            You notice Lewis Mountain is circled with a handwritten note "for negroes." That's odd.

            You heard from your friends in DC and Baltimore that other spaces in Shenandoah were integrated, but the map doesn't list them.

          </p>

          <p class="mt-8 text-neutral-700">

            You decide to drive south along Skyline Drive toward Lewis Mountain.

          </p>

          <div class="mt-12">

            <AudioPlayer :src="audio_s1e2_334_505" :track="track_s1e2_334_505" />
          
            <div class="mt-3 text-xs italic">Source: Driving the Green Book - Macmillan Podcasts - S1:E2</div>

          </div>

          <RouterLink
          
            class="inline-flex items-center gap-4 px-6 py-4 mt-12 font-bold text-white bg-green-700 transition-colors pointer-events-auto
            
              hover:bg-green-800 focus-visible:bg-green-800 hover:underline focus-visible:underline"
          
            to="/activity/2/part/5">

            <span>Continue</span>

            <ArrowRightCircleIcon class="w-8" />

          </RouterLink>

        </div>

      </div>

    </div>

  </article>

</template>
